var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { FormApi } from '../api';
import { FormModel } from '../models';
import { FormRaw } from './FormRaw';
import { FormSkeleton } from './FormSkeleton';
import { MultiLangFormEdit } from './MultiLangFormEdit';
export var Form = observer(function (props) {
    var ownerEntityId = props.ownerEntityId, formDTO = props.formDTO, _a = props.isShowForm, isShowForm = _a === void 0 ? true : _a, _b = props.readOnly, readOnly = _b === void 0 ? false : _b, _c = props.multiLang, multiLang = _c === void 0 ? false : _c, _d = props.isLoading, isLoading = _d === void 0 ? false : _d, intlStore = props.intlStore, formRawProps = __rest(props, ["ownerEntityId", "formDTO", "isShowForm", "readOnly", "multiLang", "isLoading", "intlStore"]);
    var locale = intlStore.locale;
    var _e = props.lang, lang = _e === void 0 ? locale : _e;
    var formModel = useMemo(function () { return new FormModel(ownerEntityId, formDTO); }, [ownerEntityId, formDTO]);
    var formApi = useMemo(function () {
        return new FormApi({
            lang: multiLang ? locale : lang,
            readOnly: readOnly,
            multiLang: multiLang,
        }, formModel);
    }, [formModel, locale, readOnly, lang, multiLang]);
    return (React.createElement(React.Fragment, null, isShowForm &&
        (isLoading ? (React.createElement(FormSkeleton, null)) : multiLang && !readOnly ? (React.createElement(MultiLangFormEdit, __assign({ intlStore: intlStore, formApi: formApi }, formRawProps))) : (React.createElement(FormRaw, __assign({ formApi: formApi, locale: locale }, formRawProps))))));
});
